import React from 'react'
import { useInvoiceListContext } from './Context'
import { IssuePeriodPicker } from './filters/IssuePeriodPicker'
import { HorizontalStack } from '@ztechapps/webui.util'
import { formatMoney, formatNumber } from '@ztechapps/common.utils'
import { List } from './List'
import { FinalizeButton } from './finalize-invoice/FinalizeButton'
import { Card } from 'react-bootstrap'
import { Toolbox } from './Toolbox'
import { StatusPicker } from './filters/StatusPicker'

export const Layout = () => {
  const context = useInvoiceListContext()

  return (
    <div>
      <HorizontalStack gap={3} className="justify-content-between">
        <HorizontalStack gap={1}>
          <FinalizeButton />

          <div>
            <IssuePeriodPicker />
          </div>
          <div>
            <StatusPicker />
          </div>

          <div>
            <Toolbox />
          </div>
        </HorizontalStack>

        <HorizontalStack gap={2} className="justify-content-end">
          <Card className="text-bg-success ">
            <Card.Body className="p-2">
              <span>Total Invoice: </span>
              <span className="h4">{formatNumber(context.totalInvoices)}</span>
            </Card.Body>
          </Card>

          <Card className="text-bg-success ">
            <Card.Body className="p-2">
              <span>Total Amount: </span>
              <span className="font-bold h4">{formatMoney(context.totalAmount)}</span>
            </Card.Body>
          </Card>
        </HorizontalStack>
      </HorizontalStack>
      <hr />

      <List />
    </div>
  )
}
